export function calculateReadingTime(content) {
    const wordsPerMinute = 225; // Adjust as needed
    const wordCount = content.split(/\s+/).length;
    const readingTimeInMinutes = Math.ceil(wordCount / wordsPerMinute);
    return readingTimeInMinutes;
  }